import React, {useState} from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {connect, useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap";


// components
import SelectWeekDay from "../../../../components/select/selectWeekDay";
import {showToastCustom} from "../../../../components/toast/customToast";
import {CustomMiniButtonX, GenericTableButton} from "../../../../components/buttons/buttonsActions";

// labels
import {REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_SAVE} from "../../../../components/i18n/toolTips";

// services
import {scheduleHotelActivityService} from "../../../../jwt/_services/hotel/hotelScheduleService";

// actions
import { setLoading } from "../../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";
import Loading from "../../../../components/loader/Loading";
import ModalFormTitle from "../../../../components/genericComponents/ModalFormTitle";



const ScheduleFrom = props => {
    const roomTypeState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:activity } = roomTypeState?.data || {};

    const statePath = `${props.path}/schedules`;
    const componentState = useSelector(state => getStateByPath(state, statePath));
    const { udn, editMode, domainObject, loading } = componentState?.data;

    const [status, setStatus] = useState( domainObject?.status || true )
    const [dayOfWeek, setDayOfWeek] = useState( domainObject?.dayOfWeek >=0 ?domainObject?.dayOfWeek : null )

    const validationSchema = Yup.object().shape({
        hourStart: Yup.string().required( REQUIRED ),
        hourEnd: Yup.string().required( REQUIRED ),
    });

    const {register, reset, handleSubmit, errors} = useForm({
        validationSchema,
        defaultValues: {
            id: domainObject?.id,
            hourStart: domainObject?.hourStart,
            hourEnd: domainObject?.hourEnd,
        }
    });

    const onSubmit = (data, _) => {
        if(dayOfWeek == null || dayOfWeek == undefined)
            return showToastCustom('error', 'Debe seleccionar un día de la semana');

        let requestData = {
            ...data,
            activity: { id: activity?.id },
            status,
            dayOfWeek:`${dayOfWeek}`
        };

        if(editMode){
            requestData.id = domainObject?.id
            genericIndexedActions.update(statePath, scheduleHotelActivityService, domainObject?.id, requestData, closeForm) // vincular la amenidad con el tipo de habitación
            return

        }

        genericIndexedActions.save(statePath, scheduleHotelActivityService, requestData, closeForm) // vincular la amenidad con el tipo de habitación
    };

    const closeForm = () => {
        reset();
        props.toggle()
    }

    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >

        <Card className={'card-modal'}>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <ModalFormTitle
                    domainObject={domainObject}
                    editMode={editMode}
                    udn={udn}
                />
                <div className="top-right">
                    <GenericTableButton
                        toolTip={TT_SAVE}
                        icon={'fa-save'}
                        permission={'add'}
                        type={'button'}
                        onClick={handleSubmit(onSubmit)}
                        disabled={loading}
                    />
                    <CustomMiniButtonX
                        toolTip={TT_CLOSE}
                        icon={'fa-times'}
                        permission={'search'}
                        onClick={closeForm}
                    />
                </div>
            </CardTitle>
            <CardBody>
                <Loading isLoading={loading}/>
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Día</Label>
                                <SelectWeekDay
                                    initialValue={ dayOfWeek }
                                    setExternalValue={ setDayOfWeek }
                                    className={(errors.dayOfWeek ? ' is-invalid' : '')}
                                />
                                {errors.dayOfWeek && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.dayOfWeek?.message}</div>}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Hora de inicio</Label>
                                <Input
                                    type="time"
                                    name="hourStart"
                                    innerRef={register}
                                    placeholder="Ingrese hora"
                                />
                                {errors.hourStart && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.hourStart?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Hora de fin</Label>
                                <Input
                                    type="time"
                                    name="hourEnd"
                                    innerRef={register}
                                    placeholder="Ingrese hora"
                                />
                                {errors.hourEnd && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.hourEnd?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={ status }
                                    onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </CardBody>
        </Card>
    </Modal>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ScheduleFrom)